import React, {useState, useEffect, useMemo} from 'react';
import styled from 'styled-components';
import {labels} from '../../../util/utils';
import Checkbox from '../../CoreWrappers/Checkbox';

// This component will acts as common for step 3 and step 4 of create project
// where we need to show available and connected tabs
function TabItemContainer(props) {
	const {
		id,
		isItemChecked,
		data,
		onSelectionChange,
		selectedItems,
		isItemDraggable,
		showCheckbox,
		connectedData,
		CurrentStep,
		childRenderItem,
		parentKeyListener,
		showDetailsSwitch,
		showTabName
	} = props;

	// Local state to show checkbox selection
	const [isChecked, setIsChecked] = useState(props.isItemChecked);

	// useState for isChecked is taking time to update state as it is async call. We need its latest value
	// as it is used in memo. So updating it will useeffect.
	useEffect(() => {
		setIsChecked(props.isItemChecked);
	}, [props.isItemChecked]);

	// create json data that will be passed to target node in org chart.
	// On drag... if current item is not selected... add it to selection list. Remove other selection.
	const onDragStart = (ev) => {
		CurrentStep === 4
			? ev.dataTransfer.setData('accessGroup', JSON.stringify({accessGroupId: id, data: data}))
			: ev.dataTransfer.setData('eng', JSON.stringify({engagementId: id, data: data}));
		var drag_icon = document.createElement('section');
		drag_icon.className = 'oversight-drag-container';
		drag_icon.innerHTML =
			CurrentStep === 4
				? labels.connectToAccessGroups(!isChecked ? 1 : selectedItems.length)
				: labels.connectToEngagements(!isChecked ? 1 : selectedItems.length);
		drag_icon.style.position = 'absolute';
		drag_icon.style.top = '-100px';
		drag_icon.style.right = '0px';
		document.body.appendChild(drag_icon);
		ev.dataTransfer.setDragImage(drag_icon, 150, 0);
	};

	// Select/unselect item on checkbox or card click
	const handleCheckBoxSelection = (e) => {
		if (
			(e.currentTarget.classList.contains('drag-container') ||
				e.currentTarget.classList.contains('motif-checkbox-input')) &&
			!document.getElementById('modal')?.innerHTML
		) {
			setIsChecked(!isChecked);
			setTimeout(() => {
				onSelectionChange(id, !isChecked);
			}, 10);
		}
	};

	// On item drag.
	const onItemDrag = (ev) => {
		onDragStart(ev);
		setTimeout(() => {
			if (!isChecked) {
				setIsChecked(!isChecked);
				onSelectionChange(id);
			}
		}, 5);
	};

	// Show list of draggable available content.
	const availableTabContent = useMemo(() => {
		return (
			<StyledEngagementItems>
				{showCheckbox && (
					<section className="check-eng-wrapper">
						<Checkbox
							className="checkBox"
							id={`AvailableItems_${isChecked ? 'Selected' : ''}_${id}`}
							label={''}
							name={`Checkbox_${id}`}
							checked={isChecked}
							key={`Checkbox_${id}_${isChecked}`}
							onChange={(e) => handleCheckBoxSelection(e)}
						/>
						<section
							className="drag-container"
							key={`${id}_${isItemChecked}`}
							onClick={(e) => handleCheckBoxSelection(e)}
							draggable
							onDragStart={(ev) => onItemDrag(ev)}
						>
							{childRenderItem({
								data: data,
								isItemDraggable: true,
								showDetailsSwitch: showDetailsSwitch,
								showTabName: showTabName,
								showRemoveIcon: false,
								parentTab: 'available'
							})}
						</section>
					</section>
				)}
			</StyledEngagementItems>
		);
	}, [id, parentKeyListener, isChecked, selectedItems.length, data, showDetailsSwitch, showTabName]);

	// Show list of connected content.
	const connectedTabContent = useMemo(() => {
		return (
			<StyledEngagementItems className="connected-tab-eng">
				{props.childRenderItem({
					data: data,
					isItemDraggable: false,
					showDetailsSwitch: showDetailsSwitch,
					showTabName: showTabName,
					showRemoveIcon: true,
					parentTab: 'connected'
				})}
			</StyledEngagementItems>
		);
	}, [id, parentKeyListener, connectedData.length, data, showDetailsSwitch, showTabName]);

	return <>{isItemDraggable ? availableTabContent : connectedTabContent}</>;
}

export default TabItemContainer;

const StyledEngagementItems = styled.section`
	margin-bottom: 1rem;
	.check-eng-wrapper {
		display: flex;
		align-items: center;
		background: var(--neutrals-00white);
		border: var(--px-1) solid var(--neutrals-200);
		border-radius: var(--px-8);
		padding: var(--spacing-medium) var(--spacing-large);

		.drag-container {
			width: calc(100% - 2.5rem);
		}
	}

	&:last-child {
		margin-bottom: 0;
	}
	&.connected-tab-eng {
		.action-icons-container {
			right: 2.5rem;
		}
	}
`;
